export enum IncomeType {
  SALARY = 'Salary',
  SELF_EMPLOYMENT = 'Self Employment',
  BONUS = 'Bonus',
  PENSION = 'Pension',
  STATE_PENSION = 'State Pension',
  BENEFITS = 'Benefits',
  INVESTMENT = 'Investment',
  DIVIDENDS = 'Dividends',
  RENTAL_INCOME = 'Rental Income',
  OTHER = 'Other'
}
